import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SurveyService } from '../services/survey.service';

import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-modal-survey',
  templateUrl: './modal-survey.component.html',
  styleUrls: ['./modal-survey.component.css']
})

export class ModalSurveyComponent implements OnInit {

  today = new Date();

  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localTags = localStorage.getItem('localTags');
  localIDElaboration = localStorage.getItem('localIDElaboration');
  localPages = localStorage.getItem('localPages');
  localSurvey = localStorage.getItem('localSurveyCompiled');

  facility = JSON.parse(this.localFacilities);
  id = JSON.parse(this.localID);
  tag = JSON.parse(this.localTags);
  idElaboration = JSON.parse(this.localIDElaboration);
  pages = JSON.parse(this.localPages);
  surveyCompiled = JSON.parse(this.localSurvey);

  currentFacility = this.facility[this.id];
  currentTag = this.tag[this.currentFacility.myFacilities.IdTag]

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private surveyService: SurveyService,
    private toastr: ToastrService,
    private modal: NgbActiveModal
  ) { }

  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));
  }

  close() {
    this.modal.close()
  }


  //Method used to interrupted fill of survey.
  interruptButton() {
    let isCompleted = false;
    this.surveyUpsert(isCompleted);
    this.close();
    this.router.navigate(['/analysis']);
    this.translate.get('SAVE_SURVEY_200.TITLE').subscribe((res: string) => {
      this.toastr.success(res, null, {
        positionClass: 'toast-top-center',
        timeOut: 2000
      })
    });
  }

  //API Send Survey
  surveyUpsert(isCompleted: boolean) {
    //Call Api of survey service that send survey. 
    this.surveyService.surveyUpsert(this.surveyCompiled)
      .subscribe(
        data => {
          if (isCompleted == true) {
            this.router.navigate(['/analysis'])
            this.translate.get('SEND_SURVEY_200.TITLE').subscribe((res: string) => {
              this.toastr.success(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
            });
          }
        },
        error => {
          this.router.navigate(['/errorPage']);
        }
      );
  }
}
